exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._287chnamzxkw6cb871qc15n7eyqz2kvsejgdmvf3fp43xzdnqmms1k66whs6d8cjkc2ku6zdkksgyz65v2387awyuxzbmej42manshs-ContractDetails-module-contract-details{padding-top:20px}", "", {"version":3,"sources":["C:/a/_work/5/s/src/views/SentRequestsReview/components/ContractDetails/C:/a/_work/5/s/src/views/SentRequestsReview/components/ContractDetails/ContractDetails.module.scss"],"names":[],"mappings":"AAAA,kJACE,gBAAiB,CAClB","file":"ContractDetails.module.scss","sourcesContent":[".contract-details {\r\n  padding-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"contract-details": "_287chnamzxkw6cb871qc15n7eyqz2kvsejgdmvf3fp43xzdnqmms1k66whs6d8cjkc2ku6zdkksgyz65v2387awyuxzbmej42manshs-ContractDetails-module-contract-details"
};